var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgDesktopRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 213,
    height: 287,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#54E596",
    d: "M222.785 206.611c-5.101 8.291-10.673 17.126-21.031 24.128-28.298 19.131-75.567 32.861-86.271-15.641-4.863-16.087 19.686-32.583 27.537-42.729 9.034-11.677 19.092-24.785 5.852-36.751-6.813-6.158-16.675-10.679-21.458-18.723-6.89-11.591-9.722-20.979-10.856-34.768-2.192-26.658 34.334-44.602 57.295-37.255 40.193 12.86 58.458 54.932 61.93 93.563 2.122 23.617-.412 47.716-12.998 68.176Z",
    style: {
      stroke: "none",
      strokeOpacity: 1,
      fill: "#518d64",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken",
      fill: "#bfa1d6",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#D096FE",
    rx: 47.548,
    ry: 55.241,
    style: {
      fill: "#bfa1d6",
      fillOpacity: 1
    },
    transform: "matrix(-.93967 .34292 -.34217 -.93933 106.581 218.54)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeWidth: 4,
    d: "M75.92 192.5v56.685l18.375-4.97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeWidth: 4,
    d: "M76.033 212.851c-20.464 30.726-30.132 5.123-30.132 5.123M120.244 203c-8.316 23.687-26.314 11.575-26.314 11.575M83.59 252.204c10.276 13.178 27.029 3.925 28.195-4.84"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken",
      stroke: "#fae89a",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#F7B568",
    strokeWidth: 6,
    d: "M58.728 111.294c-7.285-20 3.571-42.518 24.531-50.167 20.96-7.65 43.749 2.59 51.034 22.59 1.91 5.245 1.731 7.83 1.102 9.156-.575 1.212-1.959 2.25-5.241 3.121-2.381.632-5.2 1.048-8.542 1.54-1.265.187-2.604.384-4.023.609-5.027.794-10.74 1.895-16.616 4.039-5.864 2.14-11.242 5.085-16.03 7.865-1.083.628-2.127 1.243-3.137 1.837-3.55 2.091-6.672 3.929-9.542 5.233-3.736 1.697-6.237 2.089-8.04 1.495-1.655-.545-3.653-2.259-5.496-7.318Z",
    style: {
      stroke: "#fae89a",
      strokeOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDesktopRight);
export default __webpack_public_path__ + "static/media/bg_desktop_right.afbe7f510eb21162c4199cf6ecd14a90.svg";
export { ForwardRef as ReactComponent };